<template>
  <v-app>
    <v-main>
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: 'App',
};
</script>

<style>
select{
  color: black
}
@import url('https://fonts.googleapis.com/css2?family=Raleway:wght@200&display=swap');

/* Description HTML content on estate page */
.description-content p { margin-bottom: 10px; }
.description-content ul, .description-content ol { padding-left: 22px; margin-bottom: 10px; }
.description-content li { margin-bottom: 4px; }
.description-content strong { font-weight: bold; }
.description-content em { font-style: italic; }
.description-content h1, .description-content h2, .description-content h3 { font-weight: bold; margin: 14px 0 8px; }

/* TipTap editor content styling */
.ProseMirror {
  min-height: 120px;
  padding: 8px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  outline: none;
  font-size: 15px;
  line-height: 1.6;
  text-align: left !important;
}
.ProseMirror * {
  text-align: left !important;
}
.ProseMirror p {
  margin: 0 0 8px 0;
}
.ProseMirror ul,
.ProseMirror ol {
  padding-left: 20px;
}
.ProseMirror:focus {
  border-color: rgba(33,111,253,255);
}
.ProseMirror h1 { font-size: 2em; font-weight: bold; margin: 12px 0 8px; }
.ProseMirror h2 { font-size: 1.5em; font-weight: bold; margin: 10px 0 6px; }
.ProseMirror h3 { font-size: 1.2em; font-weight: bold; margin: 8px 0 4px; }
.ProseMirror u { text-decoration: underline; }
</style>
